import TSettingIvrEdit from './index.vue';

TSettingIvrEdit.install = app => {
  app.component(TSettingIvrEdit.name, TSettingIvrEdit);
};

export default TSettingIvrEdit;
